import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { PageInfoProps } from './type'

export const PageInfo = ({ totalCount, perPage, page }: PageInfoProps) => {
  const { from, to } = useMemo(() => {
    const from = perPage * (page - 1) + 1
    const to = Math.min(perPage * page, totalCount)
    return { from, to }
  }, [perPage, page, totalCount])

  const { t } = useTranslation()

  if (page < 1 || totalCount < from) return null

  return (
    <p className={clsx('tw-w-full tw-text-center tw-text-sm')}>{`${t(
      'common.pagination.fromTo',
      {
        total: totalCount,
        from,
        to,
      }
    )}`}</p>
  )
}
